import { type GaiaWebSocketResponse, gaiaWsEventBus } from "@expert/gaia";
import type { MessageSuggestion } from "@expert/shared-types";
import { useEffect } from "react";
import { getRootDispatcher } from "@/analytics";
import { useOfferChecklistStore } from "../home-product/stores/useOfferChecklistStore";

export const useSalesChecklistEventListener = () => {
    useEffect(() => {
        const cleanup = gaiaWsEventBus.on("gaia_ws_message-suggestion", ({ body }: GaiaWebSocketResponse) => {
            const transformed = body as MessageSuggestion;
            if (transformed.suggestion.responseType !== "sales-checklist-mentions") {
                return;
            }

            transformed.suggestion.sales_checklist_mentions?.forEach((mention) => {
                void getRootDispatcher().dispatchBusinessEvent("SalesChecklistBehaviorMentioned", {
                    behavior: mention.name,
                });

                useOfferChecklistStore
                    .getState()
                    .setData(transformed.sessionGroupId, { [mention.name]: mention.value });
            });
        });

        return () => cleanup();
    }, []);
};
